module.exports = __webpack_public_path__ + "static/img/dr_alert1a.1a6961b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdd/dr_alert1a.png
// module id = 1220
// module chunks = 0